import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Button/button';
import { css } from '@patternfly/react-styles';
import { getOUIAProps } from '../../helpers';
export var ButtonVariant;

(function (ButtonVariant) {
  ButtonVariant["primary"] = "primary";
  ButtonVariant["secondary"] = "secondary";
  ButtonVariant["tertiary"] = "tertiary";
  ButtonVariant["danger"] = "danger";
  ButtonVariant["link"] = "link";
  ButtonVariant["plain"] = "plain";
  ButtonVariant["control"] = "control";
})(ButtonVariant || (ButtonVariant = {}));

export var ButtonType;

(function (ButtonType) {
  ButtonType["button"] = "button";
  ButtonType["submit"] = "submit";
  ButtonType["reset"] = "reset";
})(ButtonType || (ButtonType = {}));

export var Button = function Button(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'button' : _a$component,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$isBlock = _a.isBlock,
      isBlock = _a$isBlock === void 0 ? false : _a$isBlock,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isInline = _a.isInline,
      isInline = _a$isInline === void 0 ? false : _a$isInline,
      _a$type = _a.type,
      type = _a$type === void 0 ? ButtonType.button : _a$type,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? ButtonVariant.primary : _a$variant,
      _a$iconPosition = _a.iconPosition,
      iconPosition = _a$iconPosition === void 0 ? 'left' : _a$iconPosition,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? null : _a$ariaLabel,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? null : _a$icon,
      _a$ouiaId = _a.ouiaId,
      ouiaId = _a$ouiaId === void 0 ? null : _a$ouiaId,
      _a$tabIndex = _a.tabIndex,
      tabIndex = _a$tabIndex === void 0 ? null : _a$tabIndex,
      props = __rest(_a, ["children", "className", "component", "isActive", "isBlock", "isDisabled", "isInline", "type", "variant", "iconPosition", 'aria-label', "icon", "ouiaId", "tabIndex"]);

  var Component = component;
  var isButtonElement = Component === 'button';
  return React.createElement(Component, Object.assign({}, props, {
    "aria-disabled": isButtonElement ? null : isDisabled,
    "aria-label": ariaLabel,
    className: css(styles.button, styles.modifiers[variant], isBlock && styles.modifiers.block, isDisabled && !isButtonElement && styles.modifiers.disabled, isActive && styles.modifiers.active, isInline && variant === ButtonVariant.link && styles.modifiers.inline, className),
    disabled: isButtonElement ? isDisabled : null,
    tabIndex: isDisabled && !isButtonElement ? -1 : tabIndex,
    type: isButtonElement ? type : null
  }, getOUIAProps('Button', ouiaId)), variant !== ButtonVariant.plain && icon && iconPosition === 'left' && React.createElement("span", {
    className: css(styles.buttonIcon, styles.modifiers.start)
  }, icon), children, variant !== ButtonVariant.plain && icon && iconPosition === 'right' && React.createElement("span", {
    className: css(styles.buttonIcon, styles.modifiers.end)
  }, icon));
};